import React, { JSX } from 'react';
import {
  Image,
  ImageField,
  LinkField,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';

type ArticleSummaryProps = {
  summary: string;
  image: ImageField;
  imageRight: boolean;
  date: string;
  location: string;
  heading: string;
  link: LinkField;
  phoneNumber?: string;
  linkType?: string;
  imgAlt?: string;
  marginSize: string;
  id: string;
};

const ArticleSummary = (props: ArticleSummaryProps): JSX.Element => {
  const {
    summary,
    image,
    imageRight,
    date,
    location,
    heading,
    link,
    phoneNumber,
    linkType,
    imgAlt,
    marginSize,
    id,
  } = props;

  const formattedPhoneNumber = phoneNumber?.trim();
  const linkText = link?.value?.text?.trim();

  const linkClassName =
    linkType === 'Primary'
      ? 'btn-primary'
      : linkType === 'Secondary'
        ? 'btn-secondary'
        : 'btn-tertiary';

  return (
    <div
      className={classNames(
        'article-summary',
        imageRight === true ? 'img-right' : '',
        getMarginSize(marginSize)
      )}
      id={`article-summary-${id}`}
    >
      {image && (
        <div className="summary-img">
          <Image field={image} alt={imgAlt} />
        </div>
      )}
      <div className="summary-content">
        <div className="summary-inner">
          <div className="date-and-location osf-label">
            {date && (
              <Text
                className="summary-date"
                tag="span"
                field={{ value: date }}
              />
            )}
            {location && (
              <Text
                className="summary-location"
                tag="span"
                field={{ value: location }}
              />
            )}
          </div>

          <Text
            className="summary-title osf-display-h3"
            tag="h3"
            field={{ value: heading }}
          />

          {summary && (
            <Text
              tag="p"
              className="summary-description"
              field={{ value: summary }}
            />
          )}
        </div>
        {formattedPhoneNumber ? (
          <a
            className={linkClassName}
            href={`tel:${formattedPhoneNumber}`}
          >
            {linkText || formattedPhoneNumber}
          </a>
        ) : (
          link?.value?.href &&
          linkText && (
            <a
              className={linkClassName}
              href={link.value.href}
              target={link.value.target}
              rel={
                link.value.target === '_blank'
                  ? 'noreferrer'
                  : undefined
              }
            >
              {linkText}
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default ArticleSummary;
